import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { SharedModule } from 'app/shared';
import { SponsorGuestTableComponent } from './sponsor-guest-table/sponsor-guest-table.component';



@NgModule({
  declarations: [
    AdminComponent,
    SponsorGuestTableComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class AdminModule { }
